import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthentificationService } from '../services/authentification.service';
import { SpinnerService } from '../../shared/services/spinner.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthentificationService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.spinnerService.showSpinner();
    const token = this.authService.GetToken();

    if (token) {
      const cloned = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      });
      return next.handle(cloned).pipe(
        catchError((error: HttpErrorResponse) => this.handleError(error)),
        finalize(() => this.spinnerService.hideSpinner())
      );
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => this.handleError(error)),
      finalize(() => this.spinnerService.hideSpinner())
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let translatedMessage = '';
    let errorMessageKey = '';
    switch (error.status) {
      case 400:
        errorMessageKey = error.error?.message || 'BAD_REQUEST';
        translatedMessage = this.translate.instant(errorMessageKey);
        break;

      case 401:
        errorMessageKey = error.error?.message || 'UNAUTHORIZED';
        if (errorMessageKey === 'TOKEN_EXPIRED') {
          this.authService.LogOut();
          this.router.navigate(['/login']);
        }
        translatedMessage = this.translate.instant(errorMessageKey);
        break;

      case 403:
        errorMessageKey = error.error?.message || 'FORBIDDEN';
        translatedMessage = this.translate.instant(errorMessageKey);
        break;

      case 404:
        errorMessageKey = error.error?.message || 'NOT_FOUND';
        translatedMessage = this.translate.instant(errorMessageKey);
        break;

      case 500:
        errorMessageKey = error.error?.message || 'INTERNAL_SERVER_ERROR';
        translatedMessage = this.translate.instant(errorMessageKey);
        break;

      default:
        translatedMessage = this.translate.instant('UNKNOWN_ERROR');
        break;
    }

    return throwError(() => new Error(translatedMessage));
  }
}
